<div
  [flex]="flexProps.flex ?? ''"
  [attr.flexOffset]="flexProps.flexOffset ?? ''"
  [attr.flexLayoutAlign]="flexProps.flexLayoutAlign ?? ''"
>
  <ng-container #fieldComponent></ng-container>
</div>
